import state from './moduleRecipientState.js'
import mutations from './moduleRecipientMutations.js'
import actions from './moduleRecipientActions.js'
import getters from './moduleRecipientGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
